import React, { useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import is from 'is_js';
import { toast, ToastContainer } from 'react-toastify';
import 'assets/css/custom.css';
import 'assets/css/responsive.css';
import MainLayout from './MainLayout';
import HomeLayout from './HomeLayout';
import CardForgetPassword from 'components/authentication/card/ForgetPassword';
import Home from 'components/Home';
import Error500 from 'components/errors/Error500';
import CardLogin from 'components/authentication/card/Login';
import CardPasswordReset from 'components/authentication/card/PasswordReset';
import Spinners from 'components/doc-components/Spinners';
import Dashboard from 'components/dashboards/default/dashboard';
import CardConfirmMail from 'components/authentication/card/ConfirmMail';
import Logout from 'components/authentication/card/Logout';
import Advocate from 'components/Advocate/Advocate';
import User from 'components/User/User';
import Client from 'components/Clients/Client';
import AdvocateClientCase from 'components/AdvocateClientCase/AdvocateClientCase';
import CaseNextDate from 'components/CaseNextDate/CaseNextDate';
import FilePlacement from 'components/FilePlacement/FilePlacement';
import SecurityRoleMaster from 'components/SecurityRoleMaster/SecurityRoleMaster';
import CountryMaster from 'components/CountryMaster/CountryMaster';
import CourtTypeMaster from 'components/CourtTypeMaster/CourtTypeMaster';
import SecurityMenuTreeDetails from 'components/SecurityMenuTree/SecurityMenuTreeDetails';
import CourtMaster from 'components/CourtMaster/CourtMaster';
import CaseSchedule from 'components/CaseSchedule/CaseSchedule';
import Profile from 'components/Profile/Profile';
import UpdateAdvocateSuccessBox from 'components/Profile/UpdateAdvocateSuccessBox';
import CaseTypeMaster from 'components/CaseTypeMaster/CaseTypeMaster';
import LitigationTypeMaster from 'components/LitigationTypeMaster/LitigationTypeMaster';
import ChangePassword from 'components/ChangePassword/ChangePassoword';
import ClientPayment from 'components/ClientPayment/ClientPayment';
import ClientSOA from 'components/ClientSOA/ClientSOA';
import CashCollectionReport from 'components/CashCollectionReport/CashCollectionReport';
import ClientDetailList from 'components/Client-Detail-list/ClientDetailList';
import ClientCaseListReport from 'components/CaseDiary/ClientCaseListReport';
import PendingActionReport from 'components/PendingActionReport/PendingActionReport';
import SubscriptionList from 'components/Subscriptionlist/SubscriptionList';
import CustomerInquiryList from 'components/CustomerInqueiryList/CustomerInquiryList';
import SystemSetting from 'components/SystemSettings/SystemSetting';

const Layout = () => {
  const location = useLocation();
  const HTMLClassList = document.getElementsByTagName('html')[0].classList;

  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add('windows');
    }
    if (is.chrome()) {
      HTMLClassList.add('chrome');
    }
    if (is.firefox()) {
      HTMLClassList.add('firefox');
    }
  }, [HTMLClassList]);
  const navigate = useNavigate();

  // useEffect(() => {
  //   const isAuthenticated = localStorage.getItem('UserRoles');
  //   let isValidateAdvocate =
  //     location.pathname.split('/')[1] === 'validate-advocate' ? true : false;

  //   if (!isAuthenticated && !isValidateAdvocate) {
  //     navigate('/login');
  //   }
  // }, [navigate]);

  return (
    <>
      <Routes>
        <Route element={<HomeLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/error" element={<Error500 />} />
        </Route>
        <Route path="/confirm-mail" element={<CardConfirmMail />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/forgot-password" element={<CardForgetPassword />} />
        <Route path="/login" element={<CardLogin />} />
        <Route path="/reset-password/:id" element={<CardPasswordReset />} />
        <Route path="/spinners" element={<Spinners />} />
        <Route
          path="/validate-advocate/:id/:emailOrMobileNo"
          element={<UpdateAdvocateSuccessBox />}
        />
        <Route element={<MainLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
        </Route>
        <Route element={<MainLayout />}>
          <Route path="/advocate" element={<Advocate />} />
        </Route>
        <Route element={<MainLayout />}>
          <Route path="/user" element={<User />} />
        </Route>
        <Route element={<MainLayout />}>
          <Route path="/client" element={<Client />} />
        </Route>
                <Route element={<MainLayout />}>
          <Route path="/system-settings" element={<SystemSetting />} />
        </Route>

        <Route element={<MainLayout />}>
          <Route path="/case-registration" element={<AdvocateClientCase />} />
        </Route>

        <Route element={<MainLayout />}>
          <Route path="/case-next-date" element={<CaseNextDate />} />
          <Route path="/case-next-date/:id" element={<CaseNextDate />} />
        </Route>
        <Route element={<MainLayout />}>
          <Route path="/file-placement" element={<FilePlacement />} />
        </Route>
        <Route element={<MainLayout />}>
          <Route
            path="/security-role-master"
            element={<SecurityRoleMaster />}
          />
        </Route>
        <Route element={<MainLayout />}>
          <Route path="/country-master" element={<CountryMaster />} />
        </Route>
        <Route element={<MainLayout />}>
          <Route path="/court-type-master" element={<CourtTypeMaster />} />
        </Route>
        <Route element={<MainLayout />}>
          <Route
            path="/security-menu-tree"
            element={<SecurityMenuTreeDetails />}
          />
        </Route>
        <Route element={<MainLayout />}>
          <Route path="/court-master" element={<CourtMaster />} />
        </Route>
        <Route element={<MainLayout />}>
          <Route path="/case-schedule" element={<CaseSchedule />} />
        </Route>
        <Route element={<MainLayout />}>
          <Route path="/profile" element={<Profile />} />
        </Route>
        <Route element={<MainLayout />}>
           <Route path="/case-type-master" element={<CaseTypeMaster />} />
        </Route>
        <Route element={<MainLayout />}>
           <Route path="/litigation-type-master" element={<LitigationTypeMaster />} />
        </Route>
        <Route element={<MainLayout />}>
          <Route path="/change-password" element={<ChangePassword />} />
        </Route>
        <Route element={<MainLayout />}>
          <Route path="/client-payment" element={<ClientPayment />} />
        </Route>
        <Route element={<MainLayout />}>
          <Route path="/client-report" element={<ClientSOA />} />
        </Route>
        <Route element={<MainLayout />}>
          <Route path="/client-payment-report" element={<CashCollectionReport />} />
        </Route>
        <Route element={<MainLayout />}>
          <Route path="/client-detail" element={<ClientDetailList />} />
        </Route>
        <Route element={<MainLayout />}>
          <Route path="/case-list-report" element={<ClientCaseListReport />} />
        </Route>
        <Route element={<MainLayout />}>
          <Route path="/pending-action-report" element={<PendingActionReport />} />
        </Route>
        <Route element={<MainLayout />}>
          <Route path="/subscription-list" element={<SubscriptionList />} />
        </Route>
        <Route element={<MainLayout />}>
          <Route path="/customer-inquiry" element={<CustomerInquiryList />} />
        </Route>
      </Routes>
      <ToastContainer icon={false} position={toast.POSITION.TOP_RIGHT} />
    </>
  );
};

export default Layout;